import { getIsTauriWebview } from '@/utils/user_agent';

let configuredSiteUrl: string | null = null;

export const isCustomSiteUrlEnabled = (): boolean => {
    return process.env.PUBLIC_ENABLE_CUSTOM_SITE_URL === 'true' && getIsTauriWebview();
};

if (typeof window !== 'undefined' && isCustomSiteUrlEnabled()) {
    configuredSiteUrl = localStorage.getItem('dev_site_url');
}

export const getSiteUrl = (): string => {
    if (configuredSiteUrl && isCustomSiteUrlEnabled()) {
        return configuredSiteUrl;
    }
    
    return process.env.PUBLIC_SITE_URL || process.env.EXPO_PUBLIC_SITE_URL || 'http://localhost:1337';
};

export const setSiteUrl = (url: string): void => {
    if (isCustomSiteUrlEnabled()) {
        configuredSiteUrl = url;
        localStorage.setItem('dev_site_url', url);
        window.location.reload();
    }
};

export const getStoredSiteUrl = (): string | null => {
    if (isCustomSiteUrlEnabled()) {
        return localStorage.getItem('dev_site_url');
    }
    return null;
};

export const clearStoredSiteUrl = (): void => {
    if (isCustomSiteUrlEnabled()) {
        configuredSiteUrl = null;
        localStorage.removeItem('dev_site_url');
    }
};